import { Box, Container, Typography, Link as MuiLink } from "@mui/material";
import { useLocation } from "react-router-dom";
import GoogleIcon from "@mui/icons-material/Google";
import PersonIcon from "@mui/icons-material/Person";
import { getGoogleUrl } from "Utils/OAuth2";
import CentralizedLayout from "./CentralizedLayout";

const LoginPage = () => {
    const location = useLocation();
    let from = ((location.state as any)?.from?.pathname as string) || "/";

    return (
        <CentralizedLayout>
            <Container
                disableGutters={true}
                maxWidth={false}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Box
                    width={"27rem"}
                    sx={{
                        backgroundColor: "#e5e7eb",
                        p: { xs: "1rem", sm: "2rem" },
                        borderRadius: 2,
                    }}
                >
                    <Box
                        width="100%"
                        sx={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            mb: 2,
                        }}
                    >
                        <img
                            style={{ margin: "auto" }}
                            src="/assets/images/L2_2.png"
                            alt=""
                            width="72"
                            height="72"
                        />
                    </Box>

                    <MuiLink
                        href={getGoogleUrl(from)}
                        className="bw-bgcolor"
                        sx={{
                            borderRadius: 1,
                            py: "0.6rem",
                            columnGap: "1rem",
                            textDecoration: "none",
                            color: "#fff",
                            cursor: "pointer",
                            fontWeight: 500,
                            "&:hover": {
                                className: "bw-color",
                                boxShadow: "0 1px 13px 0 rgb(0 0 0 / 55%)",
                            },
                            mb: 1,
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <GoogleIcon style={{ height: "2rem" }} />
                        Google
                    </MuiLink>
                    <MuiLink
                        href={""}
                        className="bw-bgcolor"
                        sx={{
                            borderRadius: 1,
                            py: "0.6rem",
                            columnGap: "1rem",
                            textDecoration: "none",
                            color: "#fff",
                            cursor: "pointer",
                            fontWeight: 500,
                            "&:hover": {
                                className: "bw-color",
                                boxShadow: "0 1px 13px 0 rgb(0 0 0 / 55%)",
                            },
                            mb: 1,
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        {/* <GoogleLogo style={{ height: "2rem" }} /> */}
                        <PersonIcon />
                        Guest
                    </MuiLink>
                </Box>
            </Container>
        </CentralizedLayout>
    );
};

export default LoginPage;
